
import Vue from "vue";
import MapDataViewer from "@/components/MapDataViewer.vue";
import { IDataProviderRequest } from "@/interfaces/data-provider";
import { zipObject } from "lodash";
import { useCatalog } from "@/store/catalog";
import { mapState } from "pinia";
import MetadataManager from "./MetadataManager.vue";

export default Vue.extend({
  name: "DataViewer",
  components: {
    MapDataViewer,
    MetadataManager,
  },
  data: () => ({
    showMapViewer: false,
    showSpinner: true,
    fields: new Array<string>(),
    items: new Array<any>(),
    isGeom: false,
    dpRequest: {
      paging: {
        size: 1500,
        page: 1,
      },
      orderBys: [{ columnName: "", keyword: "asc" }],
    } as IDataProviderRequest,
    currentPage: 1,
    perPage: 12,
    sortBy: "",
    sortDesc: false,
    modes: ["multi", "single", "range"],
    selectMode: "multi",
    selected: [] as any,
    totalRows: 1,
    filter: "",
    filterOn: [],
    filterOptions: true,
    showMap: false,
    selectedFromDataViewer: null as any,
    // dpRequest: {
    // default object for request, modifications made in sidebar
    paging: { page: 1, size: 1500 },
    // } as IDataProviderRequest,
    // pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
  }),
  computed: {
    ...mapState(useCatalog, [
      "tableMeta",
      "tableData",
      "catalogList",
      "selectedCatalog",
    ]),
    tableFields(): string[] {
      return this.fields; // .slice(0, 10); // Including first 10 columns in view
    },
    rows(): number {
      return this.items.length;
    },
  },
  mounted() {
    useCatalog().setSelectedDataCatId(627);
    this.loadDataViewerTable(627);
  },
  methods: {
    setCatalogTableData() {
      useCatalog().setCurrentItems(this.items);
      useCatalog().setCurrentFields(this.fields);
    },
    async loadDataViewerCat(catalogUri: string) {
      this.showSpinner = true;
      await useCatalog().setSelectedCatalog(catalogUri);
      await this.catalogChange();
      await this.loadData();
      this.showSpinner = false;
    },
    async loadData() {
      this.dpRequest.paging = { page: 1, size: 1500 };
      this.dpRequest.orderBys = [
        { columnName: this.fields[0], keyword: "asc" },
      ];
      await useCatalog()
        .getTableData({
          catalogUri: this.selectedCatalog,
          request: this.dpRequest,
        })
        .then(() => this.setTableData());
    },
    setTableData() {
      if (this.tableData?.rows.length) {
        this.items = this.tableData?.rows.map((r: unknown[]) =>
          zipObject(this.fields, r)
        );
        this.setCatalogTableData();
      }
    },
    async catalogChange() {
      // Retrieve table meta on catalog change
      await useCatalog()
        .getTableMeta({
          catalogUri: this.selectedCatalog,
          request: {},
        })
        .then(() => {
          this.setTableColumns();
        });
    },
    setTableColumns() {
      if (this.tableMeta?.columns.length) {
        this.items = [];
        this.fields = this.tableMeta.columns.map(
          (c: { columnName: string }) => c.columnName
        );
      }
    },
    loadDataViewerTable(dataCatId: number) {
      this.loadDataViewerCat("/data_viewer/" + dataCatId);
    },
    onRowSelected(items: never[] | { data_cat_id: number }[]) {
      this.items = [];
      this.fields = [];
      this.filter = "";
      this.filterOn = [];
      useCatalog().setSelectedDataCatId(items[0].data_cat_id);
      // this.dpRequest.paging = this.paging;
      this.loadDataViewerTable(items[0].data_cat_id);
      this.showMap = true;
      this.selected = items[0];
      this.selectedFromDataViewer = items;
      this.showMapViewer = true;
    },
    selectAllRows() {
      (
        this.$refs.selectableTable as Vue & { selectAllRows: () => boolean }
      ).selectAllRows();
    },
    showCatSelector() {
      // this.dpRequest = {} as IDataProviderRequest;
      this.showMapViewer = false;
      this.selected = [];
      this.filter = "";
      this.filterOn = [];
      // this.showSpinner = true;
      this.showMap = false;
      this.loadDataViewerCat("/data_viewer/627");
    },
    clearSelected() {
      (
        this.$refs.selectableTable as Vue & { clearSelected: () => boolean }
      ).clearSelected();
    },
    onFiltered(filteredItems: any[]) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      useCatalog().setCurrentItems(filteredItems);
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      if (this.showMap) {
        (
          this.$refs.mapViewComponent as Vue & { callAddLatLng: () => boolean }
        ).callAddLatLng();
      }
    },
  },
});
